import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import { isType, flattenChildren } from '../../../utils/react-children-utils/react-children-utils';
import { setNativeValue } from '../../../utils/react-utils';
import InputCounter from '../../atoms/inputs/input-counter/InputCounter';

class TextAreaContainer extends React.Component {
    constructor(props) {
        super(props);

        const input = flattenChildren(props.children).find((c) => isType(c, 'input'));
        const { defaultValue } = input.props;

        this.state = {
            defaultValue,
            currentCount: defaultValue ? defaultValue.length : 0,
        };
    }

    componentDidMount() {
        const { defaultValue } = this.state;
        setNativeValue(this.textArea, defaultValue);
    }

    handleChange(event) {
        event.preventDefault();
        const { validation, maxcount, onInput } = this.props;

        let textValue = event.target.value;

        const maxCharCount = Number.isNaN(maxcount) ? Number.parseInt(maxcount, 10) : maxcount;
        if (textValue.length > maxCharCount) {
            textValue = textValue.substring(0, maxCharCount);
            this.setState({ currentCount: maxCharCount });
        } else {
            this.setState({ currentCount: textValue.length });
        }

        // Not great but couldn't get react to update the value of the controlled
        // textarea in the DOM.
        // The substing textValue DOES get saved in the state but does not get rendered
        // as textarea.value when we try to set value=this.state.textValue in render().

        // A workaround is to render it as an uncontrolled input and manipulate the
        // object prototype value with the substringed text.
        setNativeValue(event.target, textValue);
        if (onInput) {
            onInput(event);
        }

        if (validation) {
            validation(event);
        }
    }

    render() {
        const {
            children,
            placeholder,
            invalidclass,
            maxcount,
            displaycounter,
        } = this.props;
        const { currentCount } = this.state;

        const input = flattenChildren(children).find((c) => isType(c, 'input'));
        let inputCounter = null;
        if (displaycounter) {
            inputCounter = (
                <InputCounter currentCount={currentCount} maximumCount={maxcount} />
            );
        }

        const textArea = (
            <div>
                <textarea
                    ref={(ref) => { this.textArea = ref; }}
                    className={`input ${styles.textarea} ${invalidclass}`}
                    name={input.props.name}
                    placeholder={placeholder}
                    onInput={this.handleChange.bind(this)}
                    data-testid={`${input.props.name}-textarea`}
                    maxLength={maxcount}
                />
                {inputCounter}
            </div>
        );

        return textArea;
    }
}

TextAreaContainer.propTypes = {
    children: PropTypes.node.isRequired,
    validation: PropTypes.func,
    placeholder: PropTypes.string,
    invalidclass: PropTypes.string,
    maxcount: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    displaycounter: PropTypes.bool,
    onInput: PropTypes.func,
};

TextAreaContainer.defaultProps = {
    placeholder: '',
    validation: () => { },
    invalidclass: '',
    displaycounter: false,
    onInput: null,
};

export default TextAreaContainer;
